var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"transparent":true,"color":_vm.params.data.settingMedicalExaminationStep.medicalExaminationStep.color}},[_c('span',[_vm._v(_vm._s(_vm.params.data.settingMedicalExaminationStep.medicalExaminationStep.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }